import { SSOConnectionEnvironmentTypeEnum } from './sso-connection-environment-type-enum.generated';

const x: { [index: string]: string } = {};
x[SSOConnectionEnvironmentTypeEnum.None] = 'None';
x[SSOConnectionEnvironmentTypeEnum.Production] = 'Production';
x[SSOConnectionEnvironmentTypeEnum.Testing] = 'Testing';
x[SSOConnectionEnvironmentTypeEnum.Development] = 'Development';
export const SSOConnectionEnvironmentTypeEnumDescriptions: { [indexer: string]: string } = x;
